import { types } from './sdkLoader';

/**
 * Rehydrate Sharetribe SDK value types (Money, UUID, LatLng, …) after JSON.parse
 * from our REST endpoints (e.g. GET /api/landing-listings).
 */
export const reviveSdkJson = value => JSON.parse(JSON.stringify(value), types.reviver);
